// extracted by mini-css-extract-plugin
export default {"tableContainer":"TasksTable_tableContainer__WMbJp"};